import { push } from 'connected-react-router'
import constants from './constants'
import moment from 'moment'

const handleErrorMessage = data => {
  const { errors = null, messages = null } = data
  const getFirstOnly = (array, param) => ((array && array.length > 0 && array[0][param]) || '')
  const message = getFirstOnly(errors, 'message') || getFirstOnly(messages, 'description') ||
    'Erro inesperado, favor tentar mais tarde'
  const subMessage = getFirstOnly(errors, 'subMessage')
  var result = {
    message,
    subMessage
  }
  return result
}

const secondFactorAuthentication = (orderId, secondFactorAuthConfirmated, phone) => ({
  type: 'SECOND_FACTOR_AUTHENTICATION',
  orderId,
  secondFactorAuthConfirmated,
  phone
})

const validateFundsPurchase = client => (
  serviceId,
  validatedCallback,
  invalidatedCallback
) => {
  client
    .post('/v1/purchases/ValidateFundsPurchase', {
      TypeValidate: 3,
      Service: { Type: 1, ServiceId: serviceId },
      ChannelType: 1
    })
    .then(response => {
      if (response.status === 200) {
        if (validatedCallback) validatedCallback()
      }
    })
    .catch(error => {
      let message =
        error &&
        error.response &&
        error.response.data &&
        handleErrorMessage(error.response.data)
      if (invalidatedCallback) invalidatedCallback(message)
    })
}

const insertService = (client, dispatch) => (
  serviceId,
  operatorKey,
  areaCode,
  phone,
  successCallback,
  errorCallback
) => {
  if (phone) phone = phone.replace('-', '').replace('_', '')

  client
    .post('/v1/purchases/service', {
      serviceId: serviceId.toString(),
      type: constants.SERVICETYPE_MOBILE_RECHARGE,
      configuration: [
        {
          key: 'OPERADORA',
          value: operatorKey
        },
        { key: 'DDD', value: areaCode.toString() },
        { key: 'PHONE', value: phone }
      ]
    })
    .then(response => {
      if (response.data) {
        if (response.data.status && response.data.status === 'RequiresTokenValidation') {
          dispatch(secondFactorAuthentication(response.data.id, true, response.data.phone))
          return
        }

        if (successCallback) {
          successCallback(response.data)
        } else {
          dispatch(push(`/confirmation/${response.data.id}`))
          dispatch({ type: 'MOBILE_RECHARGE_FINALIZE_ORDER_SUCCESS' })
        }
      } else {
        errorCallback('Erro inesperado, favor tentar mais tarde')
      }
      dispatch({ type: 'MOBILE_RECHARGE_FINALIZE_ORDER_END' })
    })
    .catch(error => {
      let message = handleErrorMessage(error.response.data)
      if (error.response.status === 406) {
        dispatch(secondFactorAuthentication(null, false, null))
      } else if (errorCallback) {
        errorCallback(message)
      } else {
        dispatch(showErrorMessage(message))
        dispatch({ type: 'MOBILE_RECHARGE_FINALIZE_ORDER_END' })
      }
    })
}

const showErrorMessage = message => ({
  type: 'SHOW_ERRORMESSAGE_RECHARGE',
  message: message
})

export const insertMobileRecharge = client => (
  serviceId,
  operatorKey,
  areaCode,
  phone,
  successCallback,
  errorCallback
) => {
  return (dispatch, _) => {
    dispatch({ type: 'MOBILE_RECHARGE_FINALIZE_ORDER' })
    validateFundsPurchase(client, dispatch)(
      serviceId,
      () =>
        insertService(client, dispatch)(
          serviceId,
          operatorKey,
          areaCode,
          phone,
          successCallback,
          errorCallback
        ),
      message => {
        if (errorCallback) {
          errorCallback(message)
        } else {
          dispatch({ type: 'MOBILE_RECHARGE_FINALIZE_ORDER_END' })
          dispatch(showErrorMessage(message))
        }
      }
    )
  }
}

export const scheduleMobileRecharges = client => (
  serviceId,
  operatorKey,
  areaCode,
  phone,
  initialScheduleDate,
  endScheduleDate,
  creditValue,
  pointValue
) => {
  return (dispatch, _) => {
    dispatch({ type: 'MOBILE_RECHARGE_SCHEDULE_ORDER' })
    var innitial = moment(initialScheduleDate)
    var end = moment(endScheduleDate)
    var qtdScheduleMonths = end.diff(innitial, 'months')

    client
      .post('/v3/myschedules', {
        vendorId: constants.VENDORID_CELLPHONE_RECHARGE,
        initialScheduleDate: innitial.format('YYYY/MM/DD HH:mm:ss'),
        endScheduleDate: end.format('YYYY/MM/DD HH:mm:ss'),
        qtdScheduleMonths: qtdScheduleMonths,
        creditValue: creditValue,
        pointValue: pointValue,
        serviceType: constants.SERVICETYPE_MOBILE_RECHARGE,
        operator: operatorKey,
        ddd: areaCode,
        phone: phone,
        serviceId: serviceId
      })
      .then(response => {
        if (response.status === 200 && response.data) {
          dispatch(push(`/mobile-recharge/confirmation/${response.data.id}`))
        }
        dispatch({ type: 'MOBILE_RECHARGE_SCHEDULE_ORDER_END' })
      })
      .catch(error => {
        var message = handleErrorMessage(error.response.data)
        dispatch({ type: 'MOBILE_RECHARGE_SCHEDULE_ORDER_END' })
        dispatch(showErrorMessage(message))
      })
  }
}

export const getOrderService = orderId => ({
  type: 'GET_ORDER_SERVICE',
  payload: {
    client: 'cloudloyalty',
    request: {
      method: 'get',
      url: `/v1/purchases/${orderId}/order`
    }
  }
})

export default client => ({
  insertMobileRecharge: insertMobileRecharge(client),
  getOrderService,
  scheduleMobileRecharges: scheduleMobileRecharges(client)
})



// WEBPACK FOOTER //
// ./src/features/CellphoneRecharge/actions.js